import './style.scss'
import Layer from '../../../Shared/Layer'
import { Col, Container, Row } from '@trendmicro/react-grid-system'
import Button from '../../../Shared/Form/Button'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import Loader from '../../../Shared/Loader'
import { headMyGiataDriveProHotel } from '../../../../api'
import { BUTTON_MIN_WIDTH } from '../../../Shared/Form/Button/constants'

const PropertyPublishedNoticeOverlay = ({ giataId, onClose }) => {
  const { t } = useTranslation()
  const [initialized, setInitialized] = useState(false)
  const [showOCLLink, setShowOCLLink] = useState(false)
  useEffect(() => {
    headMyGiataDriveProHotel(giataId)
      .fetchPromise
      .then((response) => {
        if (response.status === 200) {
          setShowOCLLink(true)
        }
        setInitialized(true)
      })
      .catch(() => {
        setInitialized(true)
      })
  }, [giataId])
  return (
    <Layer
      type="center"
      size="small"
      id={'property-published'}
      show={true}
      onHideClick={onClose}
      background="light-grey"
      borderRadius="20px"
      showCloseIcon={false}
      className="property-published-notice-overlay"
      closeOnEsc={true}
    >
      {initialized ? <Container fluid>
        <Row style={{ alignItems: 'center' }}>
          <Col xs={3}>
            <span className="property-published-notice-overlay__gear_icon"></span>
          </Col>
          <Col xs={9}>
            <span className="property-published-notice-overlay__header">{t('PROPERTY_PUBLISHED_NOTICE_HEADER')}</span>
            <br/>
            <br/>
            <span className="property-published-notice-overlay__subheader">
              {
                showOCLLink ? <>
                  {t('PROPERTY_PUBLISHED_NOTICE_LINK_TEXT')}
                  <br/>
                  <a target="_blank" rel="noreferrer"
                     href={'https://giatadrive.com/' + giataId}>https://giatadrive.com/{giataId}</a>
                </> : <>
                  {t('PROPERTY_PUBLISHED_NOTICE_TEXT')}
                </>
              }
            </span>
          </Col>
        </Row>
        <Row>
          <br/>
        </Row>
        <Row>
          <Button style={{ textTransform: 'uppercase' }} onClick={onClose} align="center"
                  minWidth={BUTTON_MIN_WIDTH}>{t('BUTTON_OK')}</Button>
        </Row>
      </Container> : <Loader/>
      }
    </Layer>
  )
}

export default PropertyPublishedNoticeOverlay
